import { gql } from '@apollo/client';

export const GET_CUSTOMER = gql`
  query GetCustomer {
    getCustomer {
      id
      companyName
      companyLogoImage
      formPageTitle
      termsOfUse
      privacyPolicy
      emailVerificationAcceptedTitle
      emailVerificationAcceptedFromName
      emailVerificationAcceptedContent
      emailVerificationCompletedTitle
      emailVerificationCompletedFromName
      emailVerificationCompletedContent
      createdAt
      updatedAt
      isDeleted
    }
  }
`;

export const GET_CUSTOMER_PUBLIC = gql`
  query GetCustomerPublic {
    getCustomerPublic {
      companyName
      formPageTitle
    }
  }
`;

export const GET_CUSTOMER_LEGAL_CONTENT = gql`
  query GetCustomerLegalContent {
    getCustomerLegalContent {
      termsOfUse
      privacyPolicy
    }
  }
`;
